const ACCESS_KEY = 'spa_access';
const REFRESH_KEY = 'spa_refresh';

// Centre-owner portal tokens are kept under separate keys so a logged-in
// customer and a logged-in centre never clobber each other's session.
const CENTRE_ACCESS_KEY = 'sc_centre_access';
const CENTRE_REFRESH_KEY = 'sc_centre_refresh';

export const getAccessToken = (): string | null => localStorage.getItem(ACCESS_KEY);
export const getRefreshToken = (): string | null => localStorage.getItem(REFRESH_KEY);
export const setAccessToken = (token: string) => localStorage.setItem(ACCESS_KEY, token);
export const setRefreshToken = (token: string) => localStorage.setItem(REFRESH_KEY, token);
export const removeTokens = () => {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
};

export const getCentreAccessToken = (): string | null => localStorage.getItem(CENTRE_ACCESS_KEY);
export const getCentreRefreshToken = (): string | null => localStorage.getItem(CENTRE_REFRESH_KEY);
export const setCentreAccessToken = (token: string) => localStorage.setItem(CENTRE_ACCESS_KEY, token);
export const setCentreRefreshToken = (token: string) => localStorage.setItem(CENTRE_REFRESH_KEY, token);
export const removeCentreTokens = () => {
  localStorage.removeItem(CENTRE_ACCESS_KEY);
  localStorage.removeItem(CENTRE_REFRESH_KEY);
};

